import colors from './colors';
import defaultTheme from './defaultTheme';

export default defaultTheme(colors);
